import eventEnable from '../core/eventEnable';
export default class HouseTypeViewModel{
	constructor(houseTypesWithSameName){
		eventEnable(this);
		this._houseTypesWithSameName= houseTypesWithSameName;
		this._firstHouseType = houseTypesWithSameName[0];
		this._dispatchSelectedChanged = this._dispatchSelectedChanged.bind(this);
	}
	get name(){
		return this._firstHouseType.name;
	}
	get about(){
		return this._firstHouseType.about;
	}
	get houseTypesWithSameName(){
		return this._houseTypesWithSameName;
	}
	get imageAbsolutePath(){
		return this._firstHouseType.getImageAbsolutePath();
	}
	get selected(){
		return this._selected;
	}
	set selected(value){
		if(value===this._selected)return;
		this._selected = value;
		this._dispatchSelectedChanged(value);
	}
	_dispatchSelectedChanged(value){
		this.dispatchEvent({type:'selectedchanged', value:value, houseTypeViewModel:this});
	}
}